import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                91动漫
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              正版高清动漫在线观看平台，每日更新最新番剧，为二次元爱好者打造极致追番体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  番剧分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  热血动漫
                </Link>
              </li>
              <li>
                <Link to="/category/lianai" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  恋爱动漫
                </Link>
              </li>
              <li>
                <Link to="/category/qihuan" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  奇幻动漫
                </Link>
              </li>
              <li>
                <Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  搞笑动漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>support@91anime.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9191</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>上海市浦东新区张江高科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-500">
          <p>&copy; 2026 91动漫. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="/privacy" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="/terms" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="/dmca" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}